import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse,HttpParams,HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FoodItem } from '../models/fooditem.model';
import { FoodType } from '../models/foodtype.model';
import config from "../../assets/config.json";
import { map } from 'rxjs/operators';
import foodtypebyevent from "../../assets/FoodTypeByEvent.json";
import fooditems from "../../assets/FoodItems.json";
import { Twilio } from "twilio";



@Injectable({
  providedIn: 'root'
})
export class MarriageMenuService {
  // private apiUrlfood = 'http://localhost:3000/Sp_Menu';  // Mock API URL
  // private apiUrlfoodType = 'http://localhost:3000/foodtype';  // Mock API URL
  private apiUrlfood = 'http://localhost:5000/api/GetFoodbyEvent';  // Mock API URL
  private apiUrlfoodType = 'http://localhost:5000/api/GetFoodTypebyEvent';  // Mock API URL
  private apiUrlOTP = 'https://spicetrail.co.in/sms-app/send-sms';  // Mock API URL
  private apiUrllead = 'http://localhost:5000/api/SaveCustomer';
  
  
  foods: FoodItem[] = [];

  constructor(private http: HttpClient) { }

  // getFoods(eventId: number): any {
  //   this.foods =(fooditems as any);
  // // let params = new HttpParams().set('EventId', eventId.toString());
  //    return this.foods = this.foods.filter((food) => Number(food.event) === eventId)
      
  // }

  getFoods(eventId: number): Observable<FoodItem[]> {
    return this.http.get<FoodItem[]>('assets/FoodItems.json');
  }

  getOTP(otp:number,phone:number) {
    
    let params = new HttpParams().set('otp', otp.toString()).set('phone', phone.toString());
    //return this.http.get(this.apiUrlOTP, { params })
   // return this.http.get<string>(this.apiUrlOTP, { params })
   return this.http.get(config.apiUrlOTP)
      .pipe(
        catchError((error) => {
          console.error('Error in API call:', error);
          return throwError(error);
        })
        
      );
 
        
    }


  getFoodType(eventId: number): Observable<FoodType[]> {
    return this.http.get<FoodType[]>('assets/FoodTypeByEvent.json');
   
  }

  savecustomer(name:string,location:string,date:string,menu:string,phone:string,event:string): Observable<any> {
  
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const body = { name: name, location: location, date: date , menu: menu , phone: phone,event:event };
      return this.http.post<any>(this.apiUrllead, body, { headers: headers }).pipe(
        catchError(this.handleError)
      );

      
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message, error);
    return throwError(error.message);
  }


  
}